interface Props {
	error?: string;
}

export const InputError = ({ error }: Props) => {
	if (!error) return null;

	return <p className="text-error-500 font-bold">{error}</p>;
};
